interface PaperStatusState {
  loading: boolean;
  paperStatusRole: { [key: number]: number[] };
  paperStatusById: { [key: number]: PaperStatus };
}

export const CategoryEnum = {
  In_Progress: 'in_progress',
  Rejection: 'rejection',
  Accepted: 'accepted',
};

type CategoryType = CategoryEnum.Rejection | CategoryEnum.In_Progress | CategoryEnum.Accepted;

type PaperStatusName = 'Withdrawn' | 'Deleted' | 'Awaiting decision' | string;

interface PaperStatus {
  id: number;
  track_id: number;
  name: PaperStatusName;
  category: CategoryType;
  display_name: string | null;
}

interface GetPaperStatusOk {
  data: { [key: number]: PaperStatus };
}

interface PaperStatusDTO extends Omit<PaperStatus, 'track_id'> {}

interface PostPaperStatusOk {
  data: PaperStatus;
}

interface GetPaperStatusRoleResponse {
  data: { [key: number]: number[] };
}

interface UpdatePaperStatusFormRequest {
  paper_status_id: number;
  form_ids: number[];
}
